import BaseCol from './base-col.vue'
BaseCol.install = Vue => {
  Vue.component(BaseCol.name, BaseCol)
}
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(BaseCol);
}

export default BaseCol



// WEBPACK FOOTER //
// ./src/packages/col/index.js